<script lang="ts">
  import Map from "../Map.svelte";
  import Button from "../Button.svelte";
  import { type Address } from "../../lib/api/address";
  import SharedHeading from "../SharedHeading.svelte";
  import BaseStep from "../Steps/BaseStep.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Youtube from "../Youtube.svelte";

  export let currentRoute;
  export let onNext: () => void;
  export let isLoading: boolean;
  export let selectedUserAddress: Address | null;
  export let buttonCopy: string;
  export let isValid = false;

  $: copy = $getCopy("address") as Record<string, string>;
</script>

<BaseStep {currentRoute} hideMobileArtwork={true}>
  <svelte:fragment slot="content">
    <div class="flex flex-col gap-4">
      <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />

      {#if copy.customHtml}
        {@html copy.customHtml}
      {/if}

      <Youtube videoId={copy.videoId} />

      <div class="mobile-map">
        <Map
          isMobile={true}
          markerCoordinates={selectedUserAddress && selectedUserAddress.latitude && selectedUserAddress.longitude
            ? { lat: selectedUserAddress.latitude, lng: selectedUserAddress.longitude }
            : undefined}
          mapOverlayCopy={copy.mapOverlayCopy} />
      </div>

      <div class="lg:mt-4">
        <slot name="content" />
      </div>

      <div class="flex flex-col lg:mt-6 lg:flex-row gap-4 lg:gap-6">
        <slot name="additional-action-buttons" />
        <Button
          primary
          --button-padding="0.5rem 3.5rem"
          disabled={Boolean(!isValid) || isLoading}
          isBusy={isLoading}
          on:click={onNext}>{buttonCopy}</Button>
      </div>
    </div>
  </svelte:fragment>
  <svelte:fragment slot="artwork">
    <Map
      markerCoordinates={selectedUserAddress && selectedUserAddress.latitude && selectedUserAddress.longitude
        ? { lat: selectedUserAddress.latitude, lng: selectedUserAddress.longitude }
        : undefined}
      mapOverlayCopy={copy.mapOverlayCopy} />
  </svelte:fragment>
</BaseStep>

<style>
  @media (min-width: 1024px) {
    .mobile-map {
      display: none;
    }
  }
</style>
